import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import rootReducer from './store/reducers/rootReducer';
import * as Sentry from '@sentry/browser';
import './App.scss';
import App from './App';

const packageInfo = require('../package.json');

Sentry.init({ dsn: 'https://b8c1eb6770b94f6fa7d014c5fc41c13d@o393260.ingest.sentry.io/5242075' });

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

window.versionApp = packageInfo.version;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);
